import { render, staticRenderFns } from "./VVideo.vue?vue&type=template&id=fdc03200&"
import script from "./VVideo.vue?vue&type=script&lang=js&"
export * from "./VVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports